import { Link } from "react-router-dom";
import { ProductGrid } from "./ProductGrid";
import { Button } from "./ui/button";
import { useLanguage } from "@/i18n/LanguageContext";

const ProductsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="products" className="py-32 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 space-y-6 max-w-4xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tighter">
            {t("products.title")}
          </h2>
          <div className="h-1 w-16 bg-accent mx-auto rounded-full" />
          <p className="text-lg text-muted-foreground">{t("products.subtitle")}</p>
          <p className="text-sm text-muted-foreground">{t("products.tokenNote")}</p>
        </div>
        <ProductGrid />

        <div className="mt-16 text-center space-y-6">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full text-sm text-muted-foreground">
            <span className="font-medium text-foreground">{t("products.tokensLabel")}</span>
            <span>·</span>
            <span>{t("products.tokensDesc")}</span>
          </div>
          <div>
            <Button asChild variant="outline" size="lg" className="font-sans">
              <Link to="/services">{t("products.compare")}</Link>
            </Button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProductsSection;
